import { RouteRecordRaw } from 'vue-router'
import BaseLayoutView from '@/views/layout/BaseLayoutView.vue'
import SelectTenant from '@/views/admin/SelectTenant.vue'
import UserList from '@/views/admin/UserList.vue'

export const adminRoute: RouteRecordRaw = {
  path: '/admin',
  component: BaseLayoutView,
  children: [
    { path: 'select-tenant', component: SelectTenant },
    { name: 'AdminUserList', path: 'user', component: UserList }
  ]
}
